(function($, exports) {
	exports.init = function() {
		var $question = $('.b-faq__question');

		$question.on('click', function() {
			var $answer = $(this).next('.b-faq__answer');
			$(this).toggleClass('is-active');
			$answer.slideToggle();
		});
	};
})(jQuery, (this.FAQ = {}));
